import { Ticker } from "pixi.js";

export class TickerDelay {
    public static async delay(timeMS: number): Promise<void> {
        return new Promise((resolve) => {
            const ticker = Ticker.shared;
            let time = 0;
            const timerUpdater = () => {
                time += ticker.elapsedMS;
                if (time >= timeMS) {
                    ticker.remove(timerUpdater);
                    resolve();
                }
            }
            requestAnimationFrame(() => {
                ticker.add(timerUpdater);
            });
        });
    }

    public static async delayCallback(callback: () => void, timeMS: number): Promise<void> {
        await TickerDelay.delay(timeMS);
        callback?.();
    }
}